<template>
  <div class="sf-el date-input">
    <div class="sf-date">
      <label class="sf-el__label">
        {{ label }}
        <span v-if="required" class="sf-el__required">*</span>
      </label>
      <p v-if="caption" class="sf-el__caption">{{ caption }}</p>
      <input 
        :type="dateTimeType || 'date'" 
        v-model="value" 
        :placeholder="placeholder" 
        :min="min" 
        :max="max" 
      />
    </div>
  </div>
</template>

<script>
  import { ref, watch } from 'vue';

  export default {
    name: 'DateElement',
    components: {},
    props: {
      label: String,
      description: String,
      caption: String,
      name: String,
      modelValue: String,
      min: String,
      max: String,
      placeholder: String,
      required: Boolean,
      dateTimeType: {
        type: String,
        default: 'date',
        validator: (value) => ['date', 'datetime-local'].includes(value),
      },
    },
    emits: ['update:modelValue'],
    setup(props, { emit }) {
      const value = ref(props.modelValue);
      watch(value, (newValue) => {
        emit('update:modelValue', newValue);
      });
      watch(
        () => props.modelValue,
        (newVal) => {
          value.value = newVal;
        }
      );
      return {
        value,
      };
    },
  };
</script>

<style scoped lang="scss">
  .sf-date {
    &__wrap {
      display: flex;
      gap: 24px;
      input[type='date'],
      input[type='datetime-local'] {
        max-width: 30%;
        width: 150px;
      }
      
      input[type='datetime-local'] {
        width: 200px; // Slightly wider for datetime inputs
      }
    }
  }
</style>
